/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";

import newsDashboard from "routes/newsDashboard";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle";
import logo from "assets/img/cityapplogo.png";

import AuthService from "components/Services/AuthService";


class GarbagePickupDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      hideBadge: true,
    };

    this.switchRoutes = (
      <Switch>
        {newsDashboard.map((prop, key) => {
          if (prop.redirect) return <Redirect from={prop.path} to={prop.to} key={key} />;
          return <Route path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    );

    this.resizeFunction = this.resizeFunction.bind(this);
    this.AuthService = new AuthService();
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    window.addEventListener("resize", this.resizeFunction);
  }

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }

  hideNotificationBadge = value => {
    if (!!value !== this.state.hideBadge)
      this.setState({ hideBadge: !!value });
  }

  render() {
    const { classes, ...rest } = this.props;
    const { hideBadge } = this.state;

    return (
      <div className={classes.wrapper}>
        <Sidebar
          hideNotificationBadge={this.hideNotificationBadge}
          routes={newsDashboard}
          logo={logo}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          hashClickEvents={{
            '#refresh-news': () => {
              if (confirm('¿Realmente desea limpiar la caché de las noticias?'))
                this.AuthService.authFetch("/admin/news/")
                  .then(() => {
                    alert("Las noticias se han refrescado exitosamente");
                  })
                  .catch(reason => {
                    console.error("Problem refreshing news: ", reason);
                    alert("Ocurrió un problema refrescando las noticias");
                  });
            }
          }}
          {...rest}
        />
        <div className={classes.mainPanel} ref="mainPanel">
          <Header routes={newsDashboard} handleDrawerToggle={this.handleDrawerToggle} hideBadge={hideBadge} {...rest} />
          <div className={classes.content}>
            <div className={classes.container}>{this.switchRoutes}</div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

GarbagePickupDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(GarbagePickupDashboard);
